import React, { useContext, useEffect, useState } from "react"
import TenkosyaInfo from "../../../../components/Tablet/TenkosyaInfo"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faArrowLeft,
  faHandPaper,
  faThList,
} from "@fortawesome/free-solid-svg-icons"
import GridButton from "../../../../components/Tablet/GridButton"
import { useHistory } from "react-router-dom"
import {
  selectWeatherPage,
  selectTenkoTypePage,
  tenkoListPage,
  loginPage,
} from "../../../../constant/tablet/pages"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../../globalStore/rootreducer"
import TenkoService from "../../../../service/truckcontrol/tenko/tenkoService"
import {
  TenkoDetailContext,
  TenkoHeaderContext,
  ZyomuinContext,
} from "../../context/context"
import { AppDispatch } from "../../../.."
import { setAlerts } from "../../../../globalStore/alertStore"
import KubunService from "../../../../service/master/kubun/kubunService"
import { 区分分類コード } from "../../../../constant/enum/codes"
import { 区分マスタ } from "../../../../service/master/kubun/TKubun"
import { ModalOuter } from "../../../../components/Tablet/ModalOuter"

const SelectMode = () => {
  const dispatch: AppDispatch = useDispatch()
  const history = useHistory()
  const userInfo = useSelector((root: RootState) => root.user.LoginUserInfo)
  const 営業日 = new Date().toISOString()
  const { set点呼ヘッダ情報 } = useContext(TenkoHeaderContext)
  const { set乗務員 } = useContext(ZyomuinContext)
  const { set点呼明細 } = useContext(TenkoDetailContext)
  const [共通指示事項List, set共通指示事項List] = useState<区分マスタ[]>([])
  const [modalShow, setModalShow] = useState(false)

  const get点呼ヘッダ情報 = async () => {
    try {
      // 部所内の当日の点呼情報を取得
      const 点呼情報Res = await new TenkoService().getHeader({
        点呼日: 営業日,
        部所コード: userInfo.部所コード,
      })

      if (点呼情報Res?.data != null) {
        const 点呼ヘッダ = 点呼情報Res?.data

        // 共通指示事項が空の場合、ランダムに入力
        if (点呼ヘッダ.共通指示事項1区分ID == null) {
          let index = Math.trunc(共通指示事項List.length * Math.random())
          index = index !== 0 ? index - 1 : 0

          const 共通指示事項1 = 共通指示事項List[index]
          点呼ヘッダ.共通指示事項1区分名称1 = 共通指示事項1.名称1
          点呼ヘッダ.共通指示事項1区分ID = 共通指示事項1.区分ID
          点呼ヘッダ.共通指示事項1区分コード = 共通指示事項1.区分コード
          点呼ヘッダ.共通指示事項1テキスト = 共通指示事項1.名称1
          点呼ヘッダ.共通指示事項2テキスト = 共通指示事項1.名称2
        }

        set点呼ヘッダ情報(点呼ヘッダ)
        return 点呼ヘッダ
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  const moveTenkoList = async () => {
    try {
      history.push(tenkoListPage.Route.path)
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  const moveTenko = async () => {
    try {
      // 部所内の当日の点呼情報を取得
      const 点呼ヘッダ = await get点呼ヘッダ情報()

      if (点呼ヘッダ != null) {
        // 天気の情報がないときは天気選択に移行
        if (点呼ヘッダ.天候区分ID == null) {
          history.push(selectWeatherPage.Route.path)
        } else {
          // 乗務員選択に移行
          history.push(selectTenkoTypePage.Route.path)
        }
      } else {
        // ヘッダ情報がない場合作成するために天候選択画面に遷移ずる
        history.push(selectWeatherPage.Route.path)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  useEffect(() => {
    // この画面に遷移した時点で点呼対象者の情報は問答無用で削除する
    set乗務員(undefined)
    set点呼明細(undefined)

    Promise.all([
      new KubunService().getList({
        分類コード: 区分分類コード.運行管理_勤怠.共通指示事項区分,
      }),
    ]).then(([res]) => {
      set共通指示事項List(res?.data)
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <TenkosyaInfo></TenkosyaInfo>
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>作業を選んでください</td>
          </tr>
          <tr>
            <td>
              <GridButton onTouchStartEventHandler={moveTenkoList}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <FontAwesomeIcon
                    style={{ marginRight: "2rem" }}
                    icon={faThList}
                  />
                  <span>点呼一覧</span>
                </div>
              </GridButton>
            </td>
            <td>
              <GridButton onTouchStartEventHandler={moveTenko}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <FontAwesomeIcon
                    style={{ marginRight: "2rem" }}
                    icon={faHandPaper}
                  />
                  <span>点呼開始</span>
                </div>
              </GridButton>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <div
                onTouchStart={(e) => {
                  e.preventDefault()
                  e.stopPropagation()

                  setModalShow(true)
                }}
                style={{
                  backgroundColor: "white",
                  display: "flex",
                  width: "25rem",
                  fontSize: "3rem",
                  padding: "0.5rem 1rem",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  marginBottom: "1rem",
                }}>
                <div>
                  <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon>
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}>
                  <span>戻る</span>
                </div>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <ModalOuter
        isShow={modalShow}
        dialogClassName="w-75"
        setIsShow={setModalShow}>
        <table style={{ height: "40rem", width: "100%" }}>
          <tbody>
            <tr>
              <td
                className="text-center"
                style={{
                  position: "relative",
                  fontSize: "5rem",
                }}
                colSpan={3}>
                点呼者登録画面に戻ります
                <br />
                よろしいですか？
              </td>
            </tr>
            <tr></tr>
            <tr className="text-center" style={{ fontSize: "4rem" }}>
              <td>
                <div
                  className="d-inline-block"
                  onTouchStart={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setModalShow(false)
                  }}
                  style={{
                    bottom: "0",
                    backgroundColor: CSS_PROPERTY.OK_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>戻らない</span>
                </div>
              </td>
              <td></td>
              <td>
                <div
                  className="d-inline-block"
                  onTouchStart={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    history.push(loginPage.Route.path)
                  }}
                  style={{
                    bottom: "0",
                    backgroundColor: CSS_PROPERTY.WARN_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>戻る</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ModalOuter>
    </>
  )
}

export default SelectMode
